module.exports = __webpack_public_path__ + "static/img/IMG_20160929_191756.17859fde.jpg";